// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"250":"63c0e960","264":"d9d87ef1"}[chunkId] + ".chunk.js";
};